export default __webpack_public_path__ + "static/media/trylleby-property-04.f7b5b3b9.jpg";